import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PerformanceService } from "./PerformanceService";

export const GetPerformance = createAsyncThunk(
  "ls/GetPerformance",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await PerformanceService.performanceModule().GetCoreReports(payload);

      const res = JSON.parse(response?.data);

      return res?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const ListTransaction = createAsyncThunk(
  "ls/ListTransaction",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log({ payload });
      const response =
        await PerformanceService.performanceModule().GetCoreReports(payload);
      const res = JSON.parse(response?.data);
      // console.log("res fred", res.message);
      return res?.data;
    } catch (error) {
      const err = JSON.parse(error?.response?.data?.message);
      console.log("error fred", err);
      return error?.response;
    }
  }
);

export const CusstomerListing = createAsyncThunk(
  "ls/CusstomerListing",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log({ payload });
      const response =
        await PerformanceService.performanceModule().GetCoreReports(payload);
      const res = JSON.parse(response?.data);
      return res?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const PerformanceList = createAsyncThunk(
  "ls/PerformanceList",
  async (payload) => {
    try {
      const response =
        await PerformanceService.performanceModule().PerformanceList(payload);
      return response?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const PerformanceOverview = createAsyncThunk(
  "ls/PerformanceOverview",
  async (payload) => {
    try {
      const response =
        await PerformanceService.performanceModule().PerformanceOverview(
          payload
        );
      return response?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const AgentProductPerformanceList = createAsyncThunk(
  "ls/AgentProductPerformanceList",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log({ payload });
      const response =
        await PerformanceService.performanceModule().GetCoreReports(payload);
      const res = JSON.parse(response?.data);
      return res?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const AgentPerformanceListFromReseller = createAsyncThunk(
  "ls/AgentPerformanceListFromReseller",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log({ payload });
      const response =
        await PerformanceService.performanceModule().GetCoreReports(payload);
      const res = JSON.parse(response?.data);
      return res?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const ResellerPerformanceList = createAsyncThunk(
  "ls/ResellerPerformanceList",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      console.log({ payload });
      const response =
        await PerformanceService.performanceModule().GetCoreReports(payload);
      const res = JSON.parse(response?.data);
      return res?.data;
    } catch (error) {
      return error?.response;
    }
  }
);

export const PerformanceSlice = createSlice({
  name: "Performance",
  initialState: {
    performanceList: {},
    loading: false,
  },
  extraReducers: {
    [AgentProductPerformanceList.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AgentProductPerformanceList.fulfilled]: (state, action) => {
      return {
        ...state,
        agentProductPerformance: action.payload,
        loading: false,
      };
    },
    [AgentProductPerformanceList.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [PerformanceList.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [PerformanceList.fulfilled]: (state, action) => {
      return {
        ...state,
        performanceList: action.payload,
        loading: false,
      };
    },
    [PerformanceList.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        performanceList: {},
        error: action.payload,
      };
    },

    [CusstomerListing.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CusstomerListing.fulfilled]: (state, action) => {
      return {
        ...state,
        CusstomerListing: action.payload,
        loading: false,
      };
    },
    [CusstomerListing.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ListTransaction.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ListTransaction.fulfilled]: (state, action) => {
      return {
        ...state,
        ListTransaction: action.payload,
        loading: false,
      };
    },
    [ListTransaction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [AgentPerformanceListFromReseller.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AgentPerformanceListFromReseller.fulfilled]: (state, action) => {
      return {
        ...state,
        agentPerformanceListFromReseller: action.payload,
        loading: false,
      };
    },
    [AgentPerformanceListFromReseller.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ResellerPerformanceList.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ResellerPerformanceList.fulfilled]: (state, action) => {
      return {
        ...state,
        resellerPerformance: action.payload,
        loading: false,
      };
    },
    [ResellerPerformanceList.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [GetPerformance.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [GetPerformance.fulfilled]: (state, action) => {
      return {
        ...state,
        performance: action.payload,
        loading: false,
      };
    },
    [GetPerformance.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    [PerformanceOverview.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [PerformanceOverview.fulfilled]: (state, action) => {
      return {
        ...state,
        performanceOverview: action.payload,
        loading: false,
      };
    },
    [PerformanceOverview.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export default PerformanceSlice.reducer;
